import { theme } from 'antd';
import React, { useEffect, useMemo, useRef } from 'react';

const { useToken } = theme;

const camelToKebab = (str) => str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

const generateCssVariables = (tokens, prefix = '--cms-') => {
  return Object.entries(tokens).flatMap(([key, value]) => {
    const cssKey = `${prefix}${camelToKebab(key)}`;
    if (typeof value === 'object' && value !== null) return generateCssVariables(value, `${cssKey}-`);
    return [[cssKey, value]];
  });
};

export const ThemeProvider = React.memo(({ children, className }) => {
  const { token } = useToken();
  const cssVars = useMemo(() => generateCssVariables(token), [JSON.stringify(token)]);

  useEffect(() => {
    if (document) {
      cssVars?.forEach(([key, value]) => {
        document.body.style.setProperty(key, value);
      });
    }
  }, [JSON.stringify(cssVars)]);

  return <>{children}</>;
});

export default ThemeProvider;
